export default function Features() {
  const features = [
    {
      icon: 'ri-shield-check-line',
      color: 'bg-[#06B6D4]',
      title: 'Bank-Level Encryption',
      description: 'AES-256 encryption standard ensuring your data remains completely private and secure from any threats',
    },
    {
      icon: 'ri-flashlight-line',
      color: 'bg-[#8B5CF6]',
      title: 'Lightning Fast Speed',
      description: 'Optimized servers worldwide delivering seamless browsing without compromising your connection speed',
    },
    {
      icon: 'ri-global-line',
      color: 'bg-[#F97316]',
      title: 'Global Server Network',
      description: 'Access content from anywhere with our strategically located servers across multiple continents',
    },
  ];

  return (
    <section id="features" className="py-24 bg-[#F8F9FA]">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h3 className="text-5xl font-bold text-[#0A1F44] mb-4" style={{ fontFamily: 'Inter, sans-serif' }}>
            Why Choose Our VPN
          </h3>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all hover:-translate-y-1 cursor-pointer"
            >
              <div className={`w-16 h-16 ${feature.color} rounded-full flex items-center justify-center mb-6`}>
                <i className={`${feature.icon} text-3xl text-white`}></i>
              </div>
              <h4 className="text-2xl font-bold text-[#0A1F44] mb-4">
                {feature.title}
              </h4>
              <p className="text-gray-600 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
